import React from 'react'
import {
    ImageSection,
    TypographySection,
    TitleSection,
    TitleContent,
    ContentSection,
    OverSpan,
    Image,
} from '../styles'
import { BuildProjectLabels } from 'src/types'

export const OverCardComponent = ({
    title,
    contentOne,
    contentTwo,
    contentTree,
    contentFour,
    contentOneTitle,
    contentTwoTitle,
    contentTreeTitle,
    contentFourTitle,
    image,
}: BuildProjectLabels) => {
    return (
        <>
            <OverSpan></OverSpan>
            <TypographySection>
                <TitleContent marginTop={'xxsmall'}>
                    <TitleSection
                        variant={'h2'}
                        fontSize={['xxsmall', 'xxsmall', 'xlarge', 'large']}
                        fontWeight={600}
                    >
                        {title}
                    </TitleSection>
                </TitleContent>
                <TitleContent
                    marginTop={['xxsmall', 'xxsmall', 'medium', 'medium']}
                >
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={700}
                    >
                        {contentOneTitle}
                    </ContentSection>
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={400}
                    >
                        {contentOne}
                    </ContentSection>
                </TitleContent>
                <TitleContent
                    marginTop={['xxsmall', 'xxsmall', 'medium', 'medium']}
                >
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={700}
                    >
                        {contentTwoTitle}
                    </ContentSection>
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={400}
                    >
                        {contentTwo}
                    </ContentSection>
                </TitleContent>
                <TitleContent
                    marginTop={['xxsmall', 'xxsmall', 'medium', 'medium']}
                >
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={700}
                    >
                        {contentTreeTitle}
                    </ContentSection>
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={400}
                    >
                        {contentTree}
                    </ContentSection>
                </TitleContent>
                <TitleContent
                    marginTop={['xxsmall', 'xxsmall', 'medium', 'medium']}
                    marginBottom={['xxsmall', 'xxsmall', 'xxsmall', 0]}
                >
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={700}
                    >
                        {contentFourTitle}
                    </ContentSection>
                    <ContentSection
                        variant={'h3'}
                        fontSize={['xsmall', 'xsmall', 'medium', 'xxxsmall']}
                        fontWeight={400}
                    >
                        {contentFour}
                    </ContentSection>
                </TitleContent>
            </TypographySection>
            <ImageSection marginTop={['xxsmall', 'xxsmall', 'xxsmall', 0]}>
                <Image src={image} alt={title} />
            </ImageSection>
        </>
    )
}
